const env = process.env.NODE_ENV || 'development'
const config = {
  test: require('./development.js'),
  development: require('./development.js'),
  staging: require('./staging.js'),
  production: require('./production.js'),
}

module.exports = config[env]
